/* eslint-disable camelcase */
import { isDev } from '@/core/config';
import { WhiteLabelPoweredBy } from '@/shared/components/WhiteLabelTitleHeaders/WhiteLabelPoweredBy';
import { lightOverride } from '@/shared/themes';
import { isProductionApp } from '@/core/helpers/isProductionApp';
import { TheoriqStakingPoolVault } from '@/features/vaults/constants/vaults/theoriq/theoriq-staking-pool-vault';
import { EthereumTqethVault } from '@/features/vaults/constants/vaults/theoriq/ethereum-tqeth';
import { ethereumDvsteth } from '@/features/vaults/constants/vaults/dvv/ethereum-dvsteth';
import { bscCycleNetworkVault } from '@/features/vaults/constants/vaults/bsc/bsc-cyclenetwork-vault';
import { bscStakedSolvVault } from '@/features/vaults/constants/vaults/bsc/bsc-staked-solv-vault';
import { vaultsStaging } from '@/features/vaults/vaultsStaging';
import { vaultsDev } from '@/features/vaults/vaultsDev';
import { rootstockTyrRbtcVault } from '@/features/vaults/constants/vaults/rootstock/rootstock-tyr-rbtc-vault';
import { LidoStrategy } from '@/features/vaults/constants/vaults/lido/lido-strategy';
import { lidoEarnEth } from '@/features/vaults/constants/vaults/lido/lido-earn-eth';
import { lidoEarnUsd } from '@/features/vaults/constants/vaults/lido/lido-earn-usd';
import { monadVault } from '@/features/vaults/constants/vaults/monad/monadVault';
import { mezoBtcVault } from '@/features/vaults/constants/vaults/mezo/mezo-btc-vault';
import { mezoCbBtcVault } from '@/features/vaults/constants/vaults/mezo/mezo-cb-btc-vault';
import { mezoStableVault } from '@/features/vaults/constants/vaults/mezo/mezo-stable-vault';
import { mezoBtcPreDepositVault } from '@/features/vaults/constants/vaults/mezo/mezo-btc-vault-on-ethereum';
import { mezoCbBtcPreDepositVault } from '@/features/vaults/constants/vaults/mezo/mezo-cb-btc-vault-on-ethereum';
import { ethereumMezoStableVault } from '@/features/vaults/constants/vaults/mezo/mezo-stable-vault-on-ethereum';

import { Vault } from './types';

export const ethDVVVaults: Vault[] = [ethereumDvsteth];

export const ethVaults: Vault[] = [
  {
    id: 'ethereum-re7rwbtc',
    type: 'simple-lrt',
    name: 'Re7 Labs Restaked wBTC',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain LRT vault.',
    category: 'restaking',
    address: '0x7F43fDe12A40dE708d908Fb3b9BFB8540d9Ce444',
    curators: ['re7labs'],
    operator: ['re7labs'],
    points: [
      { entity: 'mellow', startTimestamp: 1723651175 },
      { entity: 'symbiotic', startTimestamp: 1723651175 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    baseToken: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    lpTokenSymbol: 'Re7rwBTC',
    lpTokenDecimals: 18,
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7rtbtc',
    type: 'simple-lrt',
    name: 'Re7 Labs Restaked tBTC',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain LRT vault.',
    category: 'restaking',
    address: '0x3a828C183b3F382d030136C824844Ea30145b4c7',
    curators: ['re7labs'],
    operator: ['re7labs'],
    points: [
      { entity: 'mellow', startTimestamp: 1723733159 },
      { entity: 'symbiotic', startTimestamp: 1723733159 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    baseToken: '0x18084fbA666a33d37592fA2633fD49a74DD93a88',
    lpTokenSymbol: 'Re7rtBTC',
    lpTokenDecimals: 18,
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-amphrbtc',
    type: 'simple-lrt',
    name: 'Amphor Restaked BTC',
    description:
      'Amphor Restaked BTC [amphrBTC] secures, facilitates & monitors Restaked Networks curation on Symbiotic ecosystem. <br />amprBTC LRT aims at minimizing: <br />- operator authority bias<br />- unintended slashing<br />- trust/security assumptions<br />while keeping a competitive risk-adjusted yield for wBTC restakers.',
    category: 'restaking',
    address: '0x64047dD3288276d70A4F8B5Df54668c8403f877F',
    curators: ['mevcapital', 'nexo'],
    operator: ['mevcapital', 'nexo'],
    points: [
      { entity: 'mellow', startTimestamp: 1723734779 },
      { entity: 'symbiotic', startTimestamp: 1723734779 },
      { entity: 'amphor', startTimestamp: 1723734779 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    baseToken: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    lpTokenSymbol: 'amphrBTC',
    lpTokenDecimals: 18,
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'mevcapital',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 5,
        fromTimestamp: 1743458400,
      },
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'nexo',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 5,
        fromTimestamp: 1743458400,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-urlrt',
    type: 'multi-vault',
    name: 'Unified Restaked LST',
    description:
      'Introducing Unified Restaked LST (urLRT)—the future of Layered Staked Assets in EVM DeFi. urLRT embodies a revolutionary, collaborative approach, ingeniously blending yield, security, and interoperability into a seamless ecosystem. <br /><br />This cutting-edge product not only pioneers a new generation of yield-bearing assets but also serves as a robust anchor for multiple partners across intent, automation, security, and interoperability domains. Embrace the synergy with urLST, where Defi finally unifies.',
    category: 'restaking',
    address: '0x4f3Cc6359364004b245ad5bE36E6ad4e805dC961',
    curators: ['quasar'],
    operator: ['quasar'],
    points: [
      { entity: 'mellow', startTimestamp: 1723736111 },
      { entity: 'symbiotic', startTimestamp: 1723736111 },
      { entity: 'quasar', startTimestamp: 1723736111 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'urLRT',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    deposit: {
      disabled: true,
      disabledReason: `This vault is being discontinued. New deposits are stopped and existing urLRT holders are advised to withdraw. All user funds in the vault are safe.`,
    },
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0xf890434A395e3978622Ac0ae1412934bEfeB09Ff',
          withdrawal_queue: '0x7fBB995A36C85420E59d0f1B8D4874e89A660FaC',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-steaklrt',
    type: 'multi-vault',
    name: 'Steakhouse Resteaking Vault',
    description:
      'Steakhouse Resteaking Vaults are intended to allocate to networks from a fundamental perspective, keeping in mind common sense principles and building on wstETH as the liquid asset underpinning our strategies.',
    category: 'restaking',
    address: '0xBEEF69Ac7870777598A04B2bd4771c71212E6aBc',
    curators: ['steakhouse'],
    operator: ['steakhouse'],
    points: [
      { entity: 'mellow', startTimestamp: 1717836071 },
      { entity: 'symbiotic', startTimestamp: 1717836071 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'steakLRT',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'steakhouse',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 10,
        fromTimestamp: 1743458400,
      },
    ],
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0xf7Ce770AbdD1895f2CB0989D7cf2A26705FF37a7',
          withdrawal_queue: '0xC915FADA26dc6c123620A9c2a7a55c1ad45b077A',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7lrt',
    type: 'multi-vault',
    name: 'Re7 Labs LRT',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain LRT vault.',
    category: 'restaking',
    address: '0x84631c0d0081FDe56DeB72F6DE77abBbF6A9f93a',
    curators: ['re7labs'],
    operator: ['re7labs'],
    points: [
      { entity: 'mellow', startTimestamp: 1717838879 },
      { entity: 'symbiotic', startTimestamp: 1717838879 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
      {
        entity: 'tanssi',
        startTimestamp: 1750284000,
        endTimestamp: 1752019200,
        showValue: false,
      },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'Re7LRT',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 10,
        fromTimestamp: 1743458400,
      },
    ],
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x3D93b33f5E5fe74D54676720e70EA35210cdD46E',
          withdrawal_queue: '0x9668bd17947b2baD83857a75737faF17575628B8',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-amphreth',
    type: 'multi-vault',
    name: 'MEV Capital restaked ETH',
    description:
      'MEV Capital restaked ETH [amphrETH] secures, facilitates & monitors Restaked Networks curation on Symbiotic ecosystem. <br />amprETH LRT aims at minimizing: <br />- operator authority bias<br />- unintended slashing<br />- trust/security assumptions<br />while keeping a competitive risk-adjusted yield for ETH restakers.',
    category: 'restaking',
    address: '0x5fD13359Ba15A84B76f7F87568309040176167cd',
    curators: ['mevcapital'],
    operator: ['mevcapital'],
    points: [
      { entity: 'mellow', startTimestamp: 1717846523 },
      { entity: 'symbiotic', startTimestamp: 1717846523 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
      { entity: 'tanssi', startTimestamp: 1750284000, endTimestamp: 1752019200, showValue: false },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'amphrETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'mevcapital',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 10,
        fromTimestamp: 1743458400,
      },
    ],
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x446970400e1787814CA050A4b45AE9d21B3f7EA7',
          withdrawal_queue: '0x2142acB6b0424578d443A4b2E396a1b7cFb5c1e9',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-rsena',
    type: 'simple-lrt',
    name: 'Ethena LRT Vault ENA',
    description:
      'Ethena Restaked ENA [rsENA] secures, facilitates and monitors restaked network curation on the Ethena ecosystem via Symbiotic. <br /> <br /> rsENA initially will be utilized to secure cross-chain messaging of USDe via LayerZero DVNs, and later multiple layers of the Ethena Chain and Dapps built on this network.',
    category: 'restaking',
    address: '0xc65433845ecD16688eda196497FA9130d6C47Bd8',
    curators: ['mevcapital', 're7labs', 'nexo'],
    operator: ['mevcapital', 're7labs', 'nexo'],
    points: [
      { entity: 'mellow', startTimestamp: 1719251195 },
      { entity: 'symbiotic', startTimestamp: 1719251195 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    additionalTokens: [],
    baseToken: '0x57e114B691Db790C35207b2e685D4A43181e6061',
    lpTokenSymbol: 'rsENA',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-rsusde',
    type: 'simple-lrt',
    name: 'Ethena LRT Vault sUSDe',
    description:
      'Ethena Restaked sUSDe [rsUSDe] secures, facilitates and monitors restaked network curation on the Ethena ecosystem via Symbiotic. <br /> <br /> rsUSDe initially will be utilized to secure cross-chain messaging of USDe via LayerZero DVNs, and later multiple layers of the Ethena Chain and Dapps built on this network.',
    category: 'restaking',
    address: '0x82f5104b23FF2FA54C2345F821dAc9369e9E0B26',
    curators: ['mevcapital', 're7labs', 'nexo'],
    operator: ['mevcapital', 're7labs', 'nexo'],
    points: [
      { entity: 'mellow', startTimestamp: 1719253247 },
      { entity: 'symbiotic', startTimestamp: 1719253247 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    additionalTokens: [],
    baseToken: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    lpTokenSymbol: 'rsUSDe',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-lugaeth',
    type: 'multi-vault',
    name: 'Luganodes Restaked ETH',
    description:
      'Luganodes Restaked ETH will help secure and facilitate networks in the Symbiotic Ecosystem. <br /> Luganodes is a leading Swiss-operated Institutional-Grade blockchain infrastructure provider, managing over $3 Billion in staked assets across 45+ networks. We run ~7%(second largest) of the Natively Restaked Ethereum on bare metal infrastructure with 99.99% uptime.',
    category: 'restaking',
    address: '0x82dc3260f599f4fC4307209A1122B6eAa007163b',
    curators: ['luganodes'],
    operator: ['luganodes'],
    points: [
      { entity: 'mellow', startTimestamp: 1719413099 },
      { entity: 'symbiotic', startTimestamp: 1719413099 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'LugaETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x48bef6aB76E31737d94cF7b3B1dba52EDDEe1cAd',
          withdrawal_queue: '0x7d81A47925ecAC5A8E3cd839bAa14749909442de',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-pzeth',
    type: 'multi-vault',
    name: 'Renzo Restaked LST',
    description:
      'The Restaking Vault, curated by Renzo, is designed to optimize restaking opportunities for its users.',
    category: 'restaking',
    address: '0x8c9532a60E0E7C6BbD2B2c1303F63aCE1c3E9811',
    curators: ['renzo'],
    operator: ['renzo'],
    points: [
      { entity: 'mellow', startTimestamp: 1719403475 },
      { entity: 'symbiotic', startTimestamp: 1719403475 },
      { entity: 'renzo', startTimestamp: 1719403475, endTimestamp: 1743372000, show: false },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
      { entity: 'tanssi', startTimestamp: 1750284000, endTimestamp: 1752019200, showValue: false },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'pzETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0xa88e91cEF50b792f9449e2D4C699b6B3CcE1D19F',
          withdrawal_queue: '0xcDbff91f6fCcDa7367d71b065c7494526b830A89',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-hceth',
    type: 'multi-vault',
    name: 'HashKey Cloud Restaked ETH',
    description:
      'The Restaking Vault, curated by HashKey Cloud, is designed to optimize restaking opportunities for its users.<br /><br />HashKey Cloud, as a leading provider of global Web3 infrastructure and a core member of the HashKey Group, focuses on delivering professional, stable, and secure blockchain services to clients worldwide.',
    category: 'restaking',
    address: '0x375A8eE22280076610cA2B4348d37cB1bEEBeba0',
    curators: ['hashkey'],
    operator: ['hashkey'],
    points: [
      { entity: 'mellow', startTimestamp: 1733035943 },
      { entity: 'symbiotic', startTimestamp: 1733035943 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'tanssi', startTimestamp: 1750284000, endTimestamp: 1752019200, showValue: false },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'hcETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x108784D6B93A010f62b652b2356697dAEF3D7341',
          withdrawal_queue: '0xFC6D07202F5B73707AF35Cc546c181363B63bE10',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-iseth',
    type: 'multi-vault',
    name: 'InfraSingularity Restaked ETH',
    description:
      'Restaking Vault curated by InfraSingularity. InfraSingularity aims to radically transform the Web3 ecosystem by pioneering as an investor, and builder of institutional staking platform.',
    category: 'restaking',
    address: '0xcC36e5272c422BEE9A8144cD2493Ac472082eBaD',
    curators: ['infrasingularity'],
    operator: ['infrasingularity'],
    points: [
      { entity: 'mellow', startTimestamp: 1733813663 },
      { entity: 'symbiotic', startTimestamp: 1733813663 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'isETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'infrasingularity',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 10,
        fromTimestamp: 1743458400,
      },
    ],
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0xbA91473072EBD125C3cB8D251fd02bf21FDea8Df',
          withdrawal_queue: '0x5CaA0B278aa5437291dE6F6A742190e680c8e9d8',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-sibtc',
    type: 'simple-lrt',
    name: 'Staked iBTC',
    description:
      'This vault curated by the iBTC Network secures the decentralized Attestor Layer responsible for issuing the iBTC token. iBTC is a safer wrapped Bitcoin that uses the Bitcoin Layer 1 network to natively secure deposits.',
    category: 'restaking',
    address: '0xE4357bDAE017726eE5E83Db3443bcd269BbF125d',
    curators: ['ibtc'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738060055 },
      { entity: 'symbiotic', startTimestamp: 1738060055 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    baseToken: '0x20157DBAbb84e3BBFE68C349d0d44E48AE7B5AD2',
    lpTokenSymbol: 'siBTC',
    lpTokenDecimals: 8,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-rsunibtc',
    type: 'simple-lrt',
    name: 'Bedrock Restaked uniBTC',
    description:
      'Bedrock, powered by RockX, is the first multi-asset liquid restaking protocol. Leading the charge is Bedrock’s uniBTC, a Bitcoin liquid staking token that allows holders to earn Babylon rewards on their BTC while maintaining liquidity.',
    category: 'restaking',
    address: '0x08F39b3d75712148dacDB2669C3EAcc7F1152547',
    curators: ['rockx'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738319171 },
      { entity: 'symbiotic', startTimestamp: 1738319171 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    baseToken: '0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568',
    lpTokenSymbol: 'rsuniBTC',
    lpTokenDecimals: 8,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-hyvex',
    type: 'multi-vault',
    name: 'Hyve Committee-X pre-deposit',
    description:
      'HyveDA is a modular data availability protocol designed for high-throughput performance, catering to the data-intense decentralized applications.<br /><br /> It guarantees security through a fully decentralized Delegated Proof-of-Stake network powered by Symbiotic.<br /><br /> By leveraging slashing mechanisms and cryptographic proofs, HyveDA guarantees data integrity and reliability. This makes it ideal for applications such as blockchain data availability and decentralized transient storage, all within a hyper-secure framework.',
    category: 'restaking',
    address: '0x24183535a24CF0272841B05047A26e200fFAB696',
    curators: ['hyve'],
    operator: ['infrasingularity'],
    points: [
      { entity: 'mellow', startTimestamp: 1738018691 },
      { entity: 'symbiotic', startTimestamp: 1738018691 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'HYVEX',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x7e5307D99532513386bEEaC92f8616cCA76c7034',
          withdrawal_queue: '0x06Be9fDed924C853a3eAfCc32a0637Bae7029e31',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-cp0xlrt',
    type: 'multi-vault',
    name: 'cp0x LRT Conservative Vault',
    description:
      'cp0x LRT Conservative Vault is designed to provide secure and reliable restaking opportunities while adhering to a conservative, for degens like us, strategy.<br /><br /> cp0x is a Web3 community of Brodsky enthusiasts and a trusted node operator, actively participating in decentralization and governance across leading blockchain networks with a longstanding ‘cpok’.<br /><br /> With a focus on user education and transparency, cp0x ensures sustainable growth and mutual benefits for all participants.',
    category: 'restaking',
    address: '0xB908c9FE885369643adB5FBA4407d52bD726c72d',
    curators: ['cp0x'],
    operator: ['cp0x'],
    points: [
      { entity: 'mellow', startTimestamp: 1738018679 },
      { entity: 'symbiotic', startTimestamp: 1738018679 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'tanssi', startTimestamp: 1750284000, endTimestamp: 1752019200, showValue: false },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'cp0xLRT',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x82c304aa105fbbE2aA368A83D7F8945d41f6cA54',
          withdrawal_queue: '0x339D202eCEea9834590Df3e4f869E2dfE5E5a53F',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-rspond',
    type: 'simple-lrt',
    name: 'Marlin POND LRT',
    description:
      'Restaked POND [rsPOND] secures networks and protocols in the Marlin ecosystem via Symbiotic.<br/><br/>Marlin is a distributed compute network that leverages Trusted Execution Environments (TEEs) to bring verifiability and data confidentiality to AI agents, DeFi, and DeSci. rsPOND initially will be utilized to power ZK proof generation in Kalypso.',
    category: 'restaking',
    address: '0x4d12fA40e9608298be8F62Bd3627C152d8566B49',
    curators: ['cp0x'],
    operator: ['cp0x'],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    additionalTokens: [],
    baseToken: '0x57B946008913B82E4dF85f501cbAeD910e58D26C',
    lpTokenSymbol: 'rsPOND',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-resolv-restaked-wstusr',
    type: 'multi-vault',
    name: 'Re7 Resolv Restaked wstUSR',
    description:
      'Resolv is a protocol that maintains USR, a stablecoin fully backed by ETH and pegged to the US Dollar. The stablecoin’s delta-neutral design ensures price stability. Restaked USR (rstUSR) will be used as shared security across networks powered by Symbiotic security system.',
    category: 'restaking',
    address: '0x617895460004821C8DE800d4a644593cAb0aD40c',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositTokens: [
      {
        address: '0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055',
        decimals: 18,
        symbol: 'wstUSR',
      },
    ],
    // vault.asset()
    baseToken: '0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055',
    lpTokenSymbol: 'rstUSR',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-bima-usbd',
    type: 'multi-vault',
    name: 'BIMA USBD',
    description:
      "BIMA began with a clear vision to revolutionize the Bitcoin landscape by integrating it with advanced DeFi strategies. Founded by a team of industry veterans with a track record of successful exits and experiences at leading institutions such as Apollo Global Management, Celonis, and FalconX, BIMA set out to harness Bitcoin's untapped potential. Early in its journey, the project launched its MVP, attracting significant attention on testnet with over $2.6B in Bitcoin deposits and $1.1B in SUSBD minted. This technical achievement, combined with robust community engagement—reflected in more than 20,000 active users and a social media following exceeding 100K—helped establish BIMA as a frontrunner in the space. Strategic partnerships and successful fundraising milestones further cemented its foundation, paving the way for BIMA's ongoing mission to unlock enhanced capital efficiency and multichain capabilities for Bitcoin.",
    category: 'restaking',
    address: '0x7DD12E437C226018A374Bfa2BdAf48340B9942bC',
    curators: ['mevcapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositTokens: [
      {
        address: '0x6bedE1c6009a78c222D9BDb7974bb67847fdB68c',
        decimals: 18,
        symbol: 'USBD',
      },
    ],
    // vault.asset()
    baseToken: '0x6bedE1c6009a78c222D9BDb7974bb67847fdB68c',
    lpTokenSymbol: 'rsUSBD',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-symbiosis-vault',
    type: 'multi-vault',
    name: 'Symbiosis Vault',
    description:
      'Symbiosis is a cross-chain AMM DEX that pools together liquidity from different networks: L1s and L2s, EVM and non-EVM. With Symbiosis, you can easily swap any token and move your assets across different networks.',
    category: 'restaking',
    address: '0xf08e422d2986FEB7a1d798C92E043d13199EddF2',
    curators: ['symbiosis'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositTokens: [
      {
        address: '0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9',
        decimals: 18,
        symbol: 'SIS',
      },
    ],
    // vault.asset()
    baseToken: '0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9',
    lpTokenSymbol: 'rsSIS',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-aegis-restaked-syusd-vault',
    type: 'multi-vault',
    name: 'Re7 Aegis Restaked sYUSD Vault',
    description:
      'Aegis YUSD (YUSD) is a decentralized, Bitcoin-backed stablecoin designed to maintain a 1:1 peg to the US dollar while providing yield to its holders. It is backed by Bitcoin reserves held in custodial vaults, secured by smart contracts, and aims to offer transparency and independence from the traditional financial system.',
    category: 'restaking',
    address: '0x6C9cFdd534aeC8c149288228731d4D28654BDB14',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
      { entity: 'aegis', startTimestamp: 1755208800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositTokens: [
      {
        address: '0xfE0ccc9942E98C963Fe6b4e5194EB6e3Baa4cb64',
        decimals: 18,
        symbol: 'sYUSD',
      },
    ],
    // vault.asset()
    baseToken: '0xfE0ccc9942E98C963Fe6b4e5194EB6e3Baa4cb64',
    lpTokenSymbol: 'rsYUSD',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-staked-bard',
    type: 'multi-vault',
    name: 'Staked BARD',
    description:
      'Every $BARD staked reinforces the robustness of LBTC, aligning incentives and strengthening the integrity of Lombard&apos;s interoperability stack, which is powered by Chainlink&apos;s Cross-Chain Interoperability Protocol (CCIP).',
    category: 'restaking',
    address: '0x4B266366dc8fF4c0007943a679CBa1fDB845f98D',
    curators: ['lombard'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1757072291 },
      { entity: 'symbiotic', startTimestamp: 1757072291 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositTokens: [
      {
        address: '0xf0DB65D17e30a966C2ae6A21f6BBA71cea6e9754',
        decimals: 18,
        symbol: 'BARD',
      },
    ],
    // vault.asset()
    baseToken: '0xf0DB65D17e30a966C2ae6A21f6BBA71cea6e9754',
    lpTokenSymbol: 'stBARD',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 907200,
    withdrawDurationDisplay: '<3 weeks',
    tokenRewards: [
      {
        token: {
          network: 'ethereum',
          symbol: 'BARD',
          address: '0xf0DB65D17e30a966C2ae6A21f6BBA71cea6e9754',
          decimals: 18,
        },
        startTimestamp: 1757072291,
        startClaimTimestamp: 1757072291,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  LidoStrategy,
  lidoEarnEth,
  lidoEarnUsd,
  EthereumTqethVault,
];

export const ethLidoV3Vaults: Vault[] = [
  {
    id: 'ethereum-rsteth',
    type: 'multi-vault',
    name: 'Restaking Vault ETH',
    description:
      'Restaking Vault curated by Re7 Labs aims to maximize restaking opportunities for its users. P2P.org is a global staking & restaking leader with $8B and over 100k delegators across 50+ networks. Depositing this Vault you accept <a href="https://cdn.p2p.org/legal/restaking-vault.pdf" target="_blank">disclaimer</a>',
    category: 'restaking',
    address: '0x7a4EffD87C2f3C55CA251080b1343b605f327E3a',
    whiteLabeling: {
      curatorId: 'p2p',
      themeOverride: lightOverride,
      vaultTitleHeader: <WhiteLabelPoweredBy curatorId="p2p" />,
      subdomain: 'rsteth',
    },
    curators: ['re7labs'],
    cocurators: ['p2p'],
    operator: ['p2p'],
    points: [
      { entity: 'mellow', startTimestamp: 1717842227 },
      { entity: 'symbiotic', startTimestamp: 1717842227 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
      { entity: 'tanssi', startTimestamp: 1750284000, endTimestamp: 1752019200, showValue: false },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'rstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 5,
        fromTimestamp: 1743458400,
      },
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'p2p',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 5,
        fromTimestamp: 1743458400,
      },
    ],
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x7b276aAD6D2ebfD7e270C5a2697ac79182D9550E',
          withdrawal_queue: '0x351875e6348120b71281808870435bF6d5F406BD',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-coeth',
    type: 'multi-vault',
    name: 'ETH Restaking Pro',
    description:
      'Curated by Chorus One, the ETH Restaking Pro vault aims to provide users high-yield opportunities through strategic restaking. Chorus One is a research-focused institutional (re)staking leader with $3B across 50+ networks.',
    category: 'restaking',
    address: '0xd6E09a5e6D719d1c881579C9C8670a210437931b',
    curators: ['chorusone'],
    cocurators: ['gauntlet'],
    operator: ['chorusone'],
    points: [
      { entity: 'mellow', startTimestamp: 1719405311 },
      { entity: 'symbiotic', startTimestamp: 1719405311 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'coETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x7154633EdA7569021e5b1cfCbf953715F8775CA8',
          withdrawal_queue: '0x0457ca1581941f7fFa5FbeC48Bd25E6FDFb80C26',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-a41-vault',
    type: 'multi-vault',
    name: 'A41 Lido v3 Restaking Vault',
    description:
      'A41 currently manages $2B in assets, and ensures enterprise-grade security and high performance. With proven expertise in running infrastructure for projects like Lido, Mantle, Puffer, Ether.fi, Swell and others, our objective is to provide maximum restaking opportunities for the stakers while mitigating risks.<br /><br /><a href="https://narrow-cello-dab.notion.site/Why-Restake-with-A41-1b2c62052b8e80f8836de7916656d11c" target="_blank">Restake with A41</a><br /><br /><a href="https://narrow-cello-dab.notion.site/Restaking-FAQ-1aec62052b8e80c8a89ee4886059f4f4" target="_blank">FAQ</a>',
    category: 'restaking',
    address: '0x1EC4C1f8CDd7cb2Da5903701bFbD64f03ed33244',
    curators: ['a41'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'a41ETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-mevcapital-lidov3-stvault-nodeinfra',
    type: 'multi-vault',
    name: 'MEV Capital Lidov3 stVault x Nodeinfra',
    description:
      'Operated by Nodeinfra and curated by MEV Capital. Lido NofeInfra stVault secures, facilitates, and monitors SSNs curation on the Symbiotic ecosystem using Lido V3 infrastructure.<br /><br />The vault minimizes operator authority bias, mitigating the risk of unintended slashing, reducing trust and security assumptions while maintaining a competitive risk-adjusted yield for stETH restakers.',
    category: 'restaking',
    address: '0x73D596efEAe0A6833079e4fc999FD5ceE55770A5',
    curators: ['mevcapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'mevnoETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'mevcapital',
        recipient: '0x0000000000000000000000000000000000000000',
        amountPercent: 10,
        fromTimestamp: 1743458400,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-mevcapital-lidov3-stvault-alchemy',
    type: 'multi-vault',
    name: 'MEV Capital Lidov3 stVault x Alchemy',
    description:
      'Lido Alchemy stETH Vault secures, facilitates, and monitors SSNs curation on the Symbiotic ecosystem using Lido V3 infrastructure.<br /><br />The vault minimizes operator authority bias, mitigating the risk of unintended slashing, reducing trust and security assumptions while maintaining a competitive risk-adjusted yield for stETH restakers.',
    category: 'restaking',
    address: '0x1af14EBC81e8F92E0DA13D2912091d556a4Ac47B',
    curators: ['mevcapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'ALstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-mevcapital-lidov3-stvault-kiln',
    type: 'multi-vault',
    name: 'MEV Capital Lidov3 stVault x Kiln',
    description:
      'This Lido v3 pre-deposit vault accepts ETH deposits that MEV Capital will curate and restake to Symbiotic until Lido v3&apos;s release. Kiln serves as the partner node operator for Symbiotic, helping restakers secure +13 networks.<br /><br />Upon Lido v3 release, the ETH will be staked with Kiln.fi, combining Kiln&apos;s staking infrastructure excellence with MEV Capital&apos;s curation expertise.',
    category: 'restaking',
    address: '0x0F37f1ff51Fc2f8a9907eF3e226A12fDC47de4aD',
    curators: ['mevcapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'mevkstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-mevcapital-lidov3-stvault-blockscape',
    type: 'multi-vault',
    name: 'MEV Capital Lidov3 stVault x Blockscape',
    description:
      'Lido Blockscape stVault secures, facilitates, and monitors SSNs curation on the Symbiotic ecosystem using Lido V3 infrastructure. The vault minimizes operator authority bias, mitigating the risk of unintended slashing, reducing trust and security assumptions while maintaining a competitive risk-adjusted yield for stETH restakers.',
    category: 'restaking',
    address: '0x70558848f6b31AE03AD5a25868cD3d25E0fE8506',
    curators: ['mevcapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'mevblETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-stakefish-lidov3-restaked-eth',
    type: 'multi-vault',
    name: 'Stakefish Lido v3 Restaked ETH',
    description:
      'The Restaking Vault, curated by stakefish, is designed to optimize restaking opportunities for its users.<br /><br />Stakefish has been operating validators from 2018. We are one of the largest and most trusted validators in the crypto ecosystem. We support 20+ protocols and help stake over $3 billion worth of assets for both institutions and retail investors.',
    category: 'restaking',
    address: '0xb11C95eeB53FF748B6Dd4e2F9f4294F8F4030aF0',
    curators: ['stakefish'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'sfETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-stakin-boosted-eth-vault',
    type: 'multi-vault',
    name: 'Stakin Boosted ETH Vault',
    description:
      'The Boosted ETH Vault accepts ETH deposits, managed via Mellow smart contracts.<br /><br />Curated by Gauntlet, the vault restakes wstETH on Symbiotic and employs advanced risk-management strategies to optimize rewards while maintaining security.<br /><br />Until Lido v3, ETH is staked on Lido v2. Upon Lido v3 launch, ETH staking will transition to DVT using Stakin’s infrastructure.',
    category: 'restaking',
    address: '0xCeC15B365DC06Fac54114d8195B0253FffB9740F',
    curators: ['gauntlet'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'bstkETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-pier-two-all-networks',
    type: 'multi-vault',
    name: 'Pier Two All Networks',
    description:
      'Pier Two is an Australian based enterprise grade staking company. Established in 2018, Pier Two manages 24/7 staking infrastructure for its global institutional clients.',
    category: 'restaking',
    address: '0x6a834527b3a99ebB48A9C57A4d7843a028e89823',
    curators: ['steakhouse'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'ptstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-republic-enhanced-yield-vault',
    type: 'multi-vault',
    name: 'Republic Enhanced Yield Vault',
    description:
      'Republic is a leading global investment platform, leveraging blockchain to create a more inclusive and efficient global financial system. Republic’s institutional-grade staking infrastructure powers 30+ chains with $1b+ TVL, enabling regulated access to our global user base, sophisticated token issuance, and secondary trading. Learn more here: <a href="https://rep.pub/runtime" target="_blank">https://rep.pub/runtime</a>',
    category: 'restaking',
    address: '0x8f4478a6B0f049cB527EFECca6E1b23006B8812f',
    curators: ['republic'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'repETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-luganodes-lido-v3-pre-deposit-vault',
    type: 'multi-vault',
    name: 'Luganodes Lido v3 Pre-Deposit Vault',
    description: 'Pre-deposit vault for Lido v3 in collaboration with Steakhouse Financial',
    category: 'restaking',
    address: '0x9707f14B6c8200CBf6c6F2c5498D1D0019A5f15A',
    curators: ['steakhouse'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'lnstETHsteak',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-lidov3-blockscape',
    type: 'multi-vault',
    name: 'Re7 LidoV3 x Blockscape',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem. Re7 Labs is the innovation arm of digital asset investment firm Re7 Labs, taking the practical experience of DeFi risk management to our onchain vaults.<br/><br/>Blockscape is a Swiss-based blockchain infrastructure provider specializing in secure and efficient staking solutions since 2018. We focus on decentralization, self-custody, and supporting the broader blockchain ecosystem. With years of expertise, we ensure reliability and high-performance infrastructure for validators and institutional clients.',
    category: 'restaking',
    address: '0x8b0e80716c4be087C271E964E0bDc7780d32A2E8',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 're7blETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-lidov3-p-ops-team',
    type: 'multi-vault',
    name: 'Re7 LidoV3 x P-OPS Team',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem. Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain vaults.',
    category: 'restaking',
    address: '0x62F0BAf53959AF18Cab47082f5aB58A5B93e041C',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 're7popseth',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-simply-staking-lidov3-pre-deposit-vault-steakhouse',
    type: 'multi-vault',
    name: 'Simply Staking Lido v3 Pre-Deposit Vault x Steakhouse',
    description:
      'Simply Staking is an Enterprise-Grade Blockchain Infrastructure Provider based out of Malta. Operating since 2018 with over $1BN in assets staked across the 50 protocols it secures.<br/><br/>Curated by Steakhouse Financial and powered by Simply Staking, this vault aims to generate staking rewards for its users by leveraging the expertise of both entities.',
    category: 'restaking',
    address: '0x4C797D53f4772325A8aDFd509F13A2d60Daa7d02',
    curators: ['steakhouse'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'ssSTETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-provivault',
    type: 'multi-vault',
    name: 'ProviVault',
    description:
      'Proviroll’s Curated Restaking Vault (prvETH) enables secure and efficient restaking across multiple networks. Backed by wstETH, it aggregates liquidity and optimizes staking rewards. prvETH enhances capital efficiency while maintaining flexibility and security.',
    category: 'restaking',
    address: '0x54f506Bd8cC4838B42FB7640F0C811713f1d00Fb',
    curators: ['proviroll'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'prvETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-lidov3-luganodes',
    type: 'multi-vault',
    name: 'Re7 LidoV3 x Luganodes',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem. Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain vaults.',
    category: 'restaking',
    address: '0x2759E4741b370506BE2ccEf898960108e98f2faf',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 're7lugeth',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-lidov3-stakin',
    type: 'multi-vault',
    name: 'Re7 LidoV3 x Stakin',
    description:
      'The Boosted ETH Vault accepts ETH deposits, managed via Mellow smart contracts.<br/><br/>Curated by Gauntlet, the vault restakes wstETH on Symbiotic and employs advanced risk-management strategies to optimize rewards while maintaining security.<br/><br/>Until Lido v3, ETH is staked on Lido v2. Upon Lido v3 launch, ETH staking will transition to DVT using Stakin’s infrastructure.',
    category: 'restaking',
    address: '0x4C690C311d8A5aa16eC2a595D4ea3928a73C48d6',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 're7stkETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-hashkey-cloud-lidov3-pre-deposit-vault',
    type: 'multi-vault',
    name: 'HashKey Cloud Lido v3 Pre-Deposit Vault',
    description:
      'The Lido v3 pre-deposit vault, curated by HashKey Cloud, is designed to optimize restaking opportunities for its users. HashKey Cloud, as a leading provider of global Web3 infrastructure and a core member of the HashKey Group, focuses on delivering professional, stable, and secure blockchain services to clients worldwide.',
    category: 'restaking',
    address: '0x653c719E10cF65a7b902d2ba63d59FbE52D33184',
    curators: ['hashkey'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'hcstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-nansen-gauntlet-lidov3-stvault',
    type: 'multi-vault',
    name: 'Nansen x Gauntlet Lido v3 stVault',
    description:
      "The Nansen x Gauntlet Lido v3 stVault represents a strategic partnership between industry leaders Nansen and Gauntlet, focused on optimizing Lido v3 Vaults.<br/><br/>Prior to the Lido v3 launch, Gauntlet will leverage its expertise to curate restaking strategies on Symbiotic, while Nansen serve as the node operator for selected networks. Following the Lido v3 launch, all deposited ETH will be staked through Nansen's infrastructure, with Gauntlet developing and managing yield-enhancing strategies.<br/><br/>Nansen: A premier onchain analytics platform managing over $1 billion AUD and supporting more than 80,000 delegators across 30+ networks. Gauntlet: Specialists in cryptoeconomic modeling, currently overseeing more than $600 million in assets under management across curated vaults.",
    category: 'restaking',
    address: '0xE1C01ebE1B65034F1e4dD7F65D5A6eC05233C5ec',
    curators: ['gauntlet'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'nanETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-dsrv-vault',
    type: 'multi-vault',
    name: 'DSRV Vault',
    description:
      'DSRV is an integrated blockchain solutions company with the mission of enriching the crypto ecosystem via stronger connectivity. We strive to be your gateway to a suite of all-comprehensive blockchain services. Everything distributed, served complete.',
    category: 'restaking',
    address: '0xF575F1C3DAd6B47f2045015baE313cA885921C8B',
    curators: ['dsrv'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'vstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-cosmostation-vault',
    type: 'multi-vault',
    name: 'Cosmostation Vault',
    description:
      'Cosmostation is an institutional-grade cryptocurrency infrastructure provider, managing billions of dollars across 70 protocols. Since 2018, we have served more than 500k users globally, providing products that enable protocols to scale.',
    category: 'restaking',
    address: '0xeDB7FA2aD67974C309c14Bb3610eE2E6703B5C04',
    curators: ['cosmostation'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'stationETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-kukis-global-vault',
    type: 'multi-vault',
    name: 'Kukis Global Vault',
    description:
      'Kukis Global is securing over $900M across the chains we operate on, most of it on Ethereum. We are part of the Lido curated set and are one of the founding oracles with Chainlink and has been working with them since 2019.',
    category: 'restaking',
    address: '0xcAfC35fB68DFCD6AF2BC264E687c6c0279284068',
    curators: ['cp0x'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'kgETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-infrasingularity-restaked-eth',
    type: 'multi-vault',
    name: 'InfraSingularity Restaked ETH',
    description:
      'Restaking Vault curated by InfraSingularity. InfraSingularity aims to radically transform the Web3 ecosystem by pioneering as an investor, and builder of institutional staking platforms.',
    category: 'restaking',
    address: '0xD024d4e1B0ac157aa5BDFDF96388e8dc9a43b19f',
    curators: ['infrasingularity'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'isETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 'infrasingularity',
        recipient: '0x903D4E20a3b70D6aE54E1Cb91Fec2E661E2af3A5',
        amountPercent: 10,
        fromTimestamp: 1757368800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-nodes-guru-vault',
    type: 'multi-vault',
    name: 'Nodes.Guru Vault',
    description:
      'Guru of non-custodial staking. Professional node running, low fees, best uptime and 24/7 customer support.',
    category: 'restaking',
    address: '0x2818464883d4EfA130D25D414B6037570c489a7C',
    curators: ['nodes.guru'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'ngETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-re7-lidov3-node-monster',
    type: 'multi-vault',
    name: 'Re7 LidoV3 x Node.Monster',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem. Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our onchain vaults.  Node.Monster, a trusted validator and infrastructure provider, ensures secure and decentralized node operations, enhancing staking efficiency within the stVault.',
    category: 'restaking',
    address: '0x883F81511Dae16713b2255B284bad333cd3B7913',
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 're7ndmeth',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    fees: [
      {
        type: 'curation',
        network: 'ethereum',
        curator: 're7labs',
        recipient: '0xE86399fE6d7007FdEcb08A2ee1434Ee677a04433',
        amountPercent: 10,
        fromTimestamp: 1749592800,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-mevcapital-lidov3-stvault-stake-capital',
    type: 'multi-vault',
    name: 'MEV Capital Lidov3 stVault x Stake Capital',
    description:
      'Operated by Stake Capital and curated by MEV Capital. Lido Stake Capital stVault secures, facilitates, and monitors SSNs curation on the Symbiotic ecosystem using Lido V3 infrastructure.<br /><br />The vault minimizes operator authority bias, mitigating the risk of unintended slashing, reducing trust and security assumptions while maintaining a competitive risk-adjusted rewards for stETH restakers.<br /><br/>Vault Curator: MEV Capital<br />Node operator & co-Curator: Stake Capital',
    category: 'restaking',
    address: '0xf785a3637Fb8DC057a2a23c925e83859Ef212c8d',
    curators: ['mevcapital'],
    cocurators: ['stakecapital'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'mevstETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-stakely-gauntlet-restaking-plus',
    type: 'multi-vault',
    name: 'Stakely x Gauntlet Restaking Plus',
    description:
      'Stakely is a leading staking provider with $700M+ in total staked value, ISO27001 & SOC2 Type 2 certifications, and deep expertise in Ethereum infrastructure. Founded in 2020, they were among the first Lido node operators.<br /><br />Gauntlet is a pioneer in onchain risk management and cryptoeconomic modeling, optimizing DeFi strategies across $600M+ in curated vaults. Their data-driven approach maximizes rewards while maintaining robust security.<br /><br />This vault brings together Stakely’s proven infrastructure and Gauntlet’s strategic expertise to offer a secure and efficient Ethereum restaking solution. By combining our strengths, we aim to maximize rewards through optimized strategies.',
    category: 'restaking',
    address: '0xb2Bb0d53Fff7FF771855ad43F80c769860F627bD',
    curators: ['gauntlet'],
    cocurators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
      { entity: 'dittonetwork', startTimestamp: 1749061823 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'sgrpETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-flow-traders-restaking-vault',
    type: 'multi-vault',
    name: 'Flow Traders Restaking Vault',
    description:
      'Established in 2004, Flow Traders is a leading multi-asset market maker that has been publicly listed on the Amsterdam Stock Exchange since 2015. The firm expanded into digital assets trading in 2017, focusing on centralized exchanges before expanding its operations to include over-the-counter trading, options trading and decentralized finance. Additionally, Flow Traders strategically invests in builders and teams driving the convergence of centralized and decentralized finance.',
    category: 'restaking',
    address: '0x4b8b426D1a934b9C78f139526dc74249d40960ea',
    curators: ['flow_traders'],
    cocurators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    deposit: {
      whitelist: [
        '0xe5F981ee3Be4Cb2aF1D33b00C7A3D2A11De67924',
        '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      ],
      whitelistReason: ({ userAddress, isDepositorWhitelisted }) => {
        if (!userAddress) {
          return 'This is a private vault that only accepts deposits from a set of whitelisted addresses.';
        }

        if (!isDepositorWhitelisted) {
          return "This is a private vault that only accepts deposits from a set of whitelisted addresses. The wallet you're connected with is not authorized to make deposits.";
        }

        return null;
      },
    },
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'flowETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-fungl',
    type: 'multi-vault',
    name: 'Fungl',
    description:
      'Fungl is a curated stETH vault designed to optimize ETH staking with a focus on balanced risk, EU compliance and sustainable rewards. With a structured reserve ratio system and strategic restaking opportunities, Fungl offers a secure way to earn yield while maintaining liquidity. Whether you are a long-term staker or seeking new ways to grow your assets, Fungl provides a reliable staking experience.',
    category: 'restaking',
    address: '0x04784AeFB2f9FE31fD1ff05A4B331A5DdB46910A',
    curators: ['fungl'],
    cocurators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'FNGL',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-01node-vault',
    type: 'multi-vault',
    name: '01node Vault',
    description:
      '01node is a high-quality staking and validation service. We bring deep expertise and time-tested infrastructure, operating highly secure and reliable nodes. Our strong track record reflects our commitment to security and adherence to best practices across all services. At 01node, we aim to deliver top-tier performance and reliability through physical infrastructure deployed in tier-3 datacenters.',
    category: 'restaking',
    address: '0xE7cAe487F8Da314cCac5F36b829f061983014D65',
    curators: ['01node'],
    cocurators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: '01ETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-ultrayield-edge-allnodes',
    type: 'multi-vault',
    name: 'UltraYield x Edge x Allnodes',
    description:
      "As part of a strategic partnership between UltraYield (part of Edge Capital group) and Allnodes - this Lido V3 predeposit vault leverages the expertise of experienced strategy curators with over $450M in assets. We use our experience to allocate funds in market-neutral trades that deliver high yield without security compromises.<br /><br />We prioritize real yield over pure point-program trades with some focus on the latter for potential upside in trades where we've done extensive due diligence to ensure we know the team and the product well, and are certain of all the security audits.",
    category: 'restaking',
    address: '0x9A6340ce1282e01Cb4Ec9faae5fc5F4b60Ca8839',
    curators: ['ultrayield'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'alluETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-encapsulate-vault',
    type: 'multi-vault',
    name: 'Encapsulate Vault',
    description:
      'Others trust, We Validate! With over half a billion dollars in delegated stake, Encapsulate has a proven track record. Stake your ETH with us and earn secure, high-yield returns.',
    category: 'restaking',
    address: '0x00464CC86244AcECEB827e66719998c40F95F462',
    curators: ['encapsulate'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'encapETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-launchnodes-vault',
    type: 'multi-vault',
    name: 'Launchnodes Vault',
    description:
      'Launchnodes offers a simple strategy for restaking by combining DVT with Lido staking, to drive low risk restaking yield.',
    category: 'restaking',
    address: '0xFA1E351e89Fee843A1EdFb5efD4b3002743e3ed8',
    curators: ['launchnodes'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'LNO',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-openbitlab-vault',
    type: 'multi-vault',
    name: 'OpenbitLab Vault',
    description:
      "Active since 2016, Openbitlab Validator has supported 80+ networks across different ecosystems. It has been selected as Lido Node Advanced Operator, and is active on both Lido x SSV and Obol modules.<br /><br />cp0x is a crypto-native community actively involved in curating vaults and risk management strategies on Mellow/Symbiotic. The've developed a structured framework for defining and managing risk parameters across different strategies, and currently support several vaults as curators.",
    category: 'restaking',
    address: '0xea50De218A281a3E91D5e4033c4dd375f553d3bD',
    curators: ['cp0x'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'oblETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-xhash-dual-yield-restake-vault',
    type: 'multi-vault',
    name: 'XHash Dual-Yield Restake Vault',
    description:
      'The XHash Dual-Yield Restake Vault converts deposits to wstETH, dynamically reallocates across vetted Symbiotic AVSs, and streams both native staking yield and cross-network restaking rewards—plus Mellow + Symbiotic points—under on-chain risk controls.',
    category: 'restaking',
    address: '0x3EE460eFfBDEb6d5e1E2345435263c19cd68975f',
    curators: ['xhash', 'cp0x'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'xstETH',
    lpTokenDecimals: 18,
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-roeth',
    type: 'multi-vault',
    name: 'Rockmelon ETH',
    description:
      'Restaking Vault curated by <a href="https://www.rockx.com" target="_blank">RockX</a> aims to maximize restaking opportunities for its users while managing slashing risk. <a href="https://www.rockx.com" target="_blank">RockX</a> is the largest Asian-based institutional grade staking and RPC provider globally. RockX runs validators for over 2 bil USD assets across 30 blockchains and nodes for more than 10k clients, including Lido, Matrixport, Amber, Bitkan and etc.',
    category: 'restaking',
    address: '0x7b31F008c48EFb65da78eA0f255EE424af855249',
    curators: ['rockx'],
    operator: ['rockx'],
    points: [
      { entity: 'mellow', startTimestamp: 1723741943 },
      { entity: 'symbiotic', startTimestamp: 1723741943 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'roETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x575d6DD4EA8636E08952Bd7f8AF977081754B1B7',
          withdrawal_queue: '0xe51241aAbE7c77F658A3Bf160D922a1E936168cd',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-ifseth',
    type: 'multi-vault',
    name: 'InfStones Restaked ETH',
    description:
      'The Restaking Vault, curated by InfStones, is designed to optimize restaking opportunities for its users. <br /> <br /> InfStones is a leading Web3 infrastructure platform, managing over 20,000 nodes spanning over 80 protocols; Trusted by Binance, OKX, Lido, Puffer, Swell, StakeStone, and numerous others.',
    category: 'restaking',
    address: '0x49cd586dd9BA227Be9654C735A659a1dB08232a9',
    curators: ['infStones'],
    operator: ['infStones'],
    points: [
      { entity: 'mellow', startTimestamp: 1719414695 },
      { entity: 'symbiotic', startTimestamp: 1719414695 },
      { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0x7A69820e9e7410098f766262C326E211BFa5d1B1',
    additionalTokens: [
      '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    ],
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'ifsETH',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    badge: 'Lido v3',
    versions: [
      {
        vaultType: 'simple-lrt',
        symbioticVault: {
          address: '0x08144D10f6Aaa152EA88a99072a659E339d6152f',
          withdrawal_queue: '0x5e4Ef16FB0C1DE57bF204cEb8cA0B154d911142e',
        },
        toTimestamp: 1751562600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
];

export const liskVaults: Vault[] = [
  {
    id: 'lisk-wsteth-vault',
    type: 'multi-vault',
    name: 'Lisk wstETH Vault',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our on-chain LRT vault.',
    category: 'restaking',
    address: '0x1b10E2270780858923cdBbC9B5423e29fffD1A44',
    compatibility: 'ERC4626',
    interop: {
      type: 'layer-zero',
      sourceCore: '0x1b10E2270780858923cdBbC9B5423e29fffD1A44',
      targetCore: '0x7E0E4B05898181a597673cD5a8FeF2B9E36bEC97',
      targetNetwork: 'ethereum',
      targetAddress: '0x628C053E196FcCB986Cf2105136Ef11e4CE5d4ED',
      sourceWithdrawalQueue: '0x5E3584d67b86f0C77FB43073A1238a943CA26188',
    },
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'lisk',
    depositTokens: [
      {
        address: '0x76D8de471F54aAA87784119c60Df1bbFc852C415',
        decimals: 18,
        symbol: 'wstETH',
      },
    ],
    baseToken: '0x76D8de471F54aAA87784119c60Df1bbFc852C415',
    lpTokenSymbol: 'lskETH',
    lpTokenDecimals: 18,
    withdrawDuration: 1296000,
    withdrawDurationDisplay: '15 days',
    tokenRewards: [
      {
        token: {
          network: 'lisk',
          symbol: 'LSK',
          address: '0xac485391EB2d7D88253a7F1eF18C37f4242D1A24',
          decimals: 18,
        },
        startTimestamp: 1747605600,
        startClaimTimestamp: 1747605600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'lisk-rsmbtc-vault',
    type: 'multi-vault',
    name: 'Lisk rsmBTC Vault',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our on-chain LRT vault.',
    category: 'restaking',
    address: '0xa67E8B2E43B70D98E1896D3f9d563f3ABdB8Adcd',
    compatibility: 'ERC4626',
    interop: {
      type: 'layer-zero',
      sourceCore: '0xa67E8B2E43B70D98E1896D3f9d563f3ABdB8Adcd',
      targetCore: '0xB2657a1EB016692509F321A4365551e2EC1173C2',
      targetNetwork: 'ethereum',
      targetAddress: '0x354822625Acd925d02ac13f1C96dba2aA5EE7cC6',
      sourceWithdrawalQueue: '0x8294c6B7ed0dEf4Bcf0c1a34c9A09Fe0880D8A13',
    },
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'lisk',
    depositTokens: [
      {
        address: '0x9BFA177621119e64CecbEabE184ab9993E2ef727',
        decimals: 18,
        symbol: ' M-BTC',
      },
    ],
    // vault.asset()
    baseToken: '0x9BFA177621119e64CecbEabE184ab9993E2ef727',
    lpTokenSymbol: 'rsM-BTC',
    lpTokenDecimals: 18,
    withdrawDuration: 1296000,
    withdrawDurationDisplay: '15 days',
    tokenRewards: [
      {
        token: {
          network: 'lisk',
          symbol: 'LSK',
          address: '0xac485391EB2d7D88253a7F1eF18C37f4242D1A24',
          decimals: 18,
        },
        startTimestamp: 1747605600,
        startClaimTimestamp: 1747605600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'lisk-lsk-vault',
    type: 'multi-vault',
    name: 'Lisk LSK Vault',
    description:
      'Re7 has been providing liquidity in DeFi since 2019 deploying capital over across yield strategies and liquid venture investing. As DeFi-native managers, we have focused on providing early liquidity to various DeFi protocols to help grow the ecosystem.<br /><br />Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to our on-chain LRT vault.',
    category: 'restaking',
    address: '0x8cf94b5A37b1835D634b7a3e6b1EE02Ce7F0CD30',
    compatibility: 'ERC4626',
    interop: {
      type: 'layer-zero',
      sourceCore: '0x8cf94b5A37b1835D634b7a3e6b1EE02Ce7F0CD30',
      targetCore: '0xcc1D3926E079c826Cd807FdF825a6777846bb5C1',
      targetNetwork: 'ethereum',
      targetAddress: '0xB1653ee92b724a033338CC17896E06275A4E9335',
      sourceWithdrawalQueue: '0x025e059BCea0eAdBb58b16db7D2e5748736F6511',
    },
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'lisk',
    depositTokens: [
      {
        address: '0xac485391EB2d7D88253a7F1eF18C37f4242D1A24',
        decimals: 18,
        symbol: 'LSK',
      },
    ],
    // vault.asset()
    baseToken: '0xac485391EB2d7D88253a7F1eF18C37f4242D1A24',
    lpTokenSymbol: 'rsLSK',
    lpTokenDecimals: 18,
    withdrawDuration: 1296000,
    withdrawDurationDisplay: '15 days',
    tokenRewards: [
      {
        token: {
          network: 'lisk',
          symbol: 'LSK',
          address: '0xac485391EB2d7D88253a7F1eF18C37f4242D1A24',
          decimals: 18,
        },
        startTimestamp: 1747605600,
        startClaimTimestamp: 1747605600,
      },
    ],
    allocations: {
      showAllocationsTab: true,
    },
  },
];

export const bscVaults: Vault[] = [bscCycleNetworkVault, bscStakedSolvVault];

export const fraxtalVaults: Vault[] = [
  {
    id: 'fraxtal-frax-vault',
    type: 'multi-vault',
    name: 'FRAX Vault',
    description:
      'The FRAX token (Prev. FXS) is the non-stable, utility token in the protocol. It is meant to be volatile and hold rights to governance and all utility of the system. Parameters that are up for governance through FRAX include adjusting various fees, allocating protocol assets, and enabling new lending pairs for Fraxlend.',
    category: 'restaking',
    address: '0x24dD1eaBEad7b3cB07b7d162439ec0A4EEC703DF',
    compatibility: 'ERC4626',
    interop: {
      type: 'layer-zero',
      sourceCore: '0x24dD1eaBEad7b3cB07b7d162439ec0A4EEC703DF',
      targetCore: '0x6408a5261578E17f858ADD039dEb72E1952E9Fe9',
      targetNetwork: 'ethereum',
      targetAddress: '0x5B2099e204f22A0ccE3806fc2093713E2780D437',
      sourceWithdrawalQueue: '0x88d282791D7d738CDf998a21310881E8B458Bb2B',
    },
    curators: ['re7labs'],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'fraxtal',
    depositTokens: [
      {
        address: '0xFc00000000000000000000000000000000000002',
        decimals: 18,
        symbol: 'WFRAX',
      },
    ],
    baseToken: '0xFc00000000000000000000000000000000000002',
    lpTokenSymbol: 'rstFRAX',
    lpTokenDecimals: 18,
    withdrawDuration: 1296000,
    withdrawDurationDisplay: '15 days',
    allocations: {
      showAllocationsTab: true,
    },
  },
];

export const holeskyVaults: Vault[] = [
  {
    id: 'holesky-mellow-lrt-vault-1',
    type: 'simple-lrt',
    name: 'Mellow LRT Vault 1 ()',
    description: 'mellow-lrt test vault',
    category: 'restaking',
    address: '0xab6B95B7F8feF87b1297516F5F8Bb8e4F33C6461',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 0 },
      { entity: 'symbiotic', startTimestamp: 0 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x1364687121E65d31D1C57F6C5636e2585481D687',
    additionalTokens: [
      '0x3F1c547b21f65e10480dE3ad8E19fAAC46C95034',
      '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
    ],
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MLV-1',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 3600,
    withdrawDurationDisplay: '<2 hours',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'holesky-multi-vault-test',
    type: 'multi-vault',
    name: 'Multi Vault Test (Holesky)',
    description: 'Multi Vault',
    category: 'restaking',
    address: '0xc3dA07f12344BE2E9212B2B40D3eB9e9aC2dBe27',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 0 },
      { entity: 'symbiotic', startTimestamp: 0 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x3660b1e06b9765D522dCD30fa3cc9Ad1ca5975dA',
    additionalTokens: [
      '0x3F1c547b21f65e10480dE3ad8E19fAAC46C95034',
      '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MVTEST',
    lpTokenDecimals: 18,
    withdrawDuration: 120,
    withdrawDurationDisplay: '<2 minutes',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'holesky-multi-vault-test-1',
    type: 'multi-vault',
    name: 'MultiVault-test-1 (Holesky)',
    description: 'Multi Vault',
    category: 'restaking',
    address: '0xD1d9c7cd66721e43579Be95BC6D13b56817Dd54D',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 0 },
      { entity: 'symbiotic', startTimestamp: 0 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0xa732745e58bD3D491ABEe6f32Cb96B142523cD8C',
    additionalTokens: [
      '0x3F1c547b21f65e10480dE3ad8E19fAAC46C95034',
      '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MV-1',
    lpTokenDecimals: 18,
    withdrawDuration: 120,
    withdrawDurationDisplay: '<2 minutes',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'holesky-multi-vault-prelaunch-test-1',
    type: 'multi-vault',
    name: 'Prelaunch-MultiVault-test-1 (Holesky)',
    description: 'Multi Vault',
    category: 'restaking',
    address: '0xc119d25470f6C4AA842772521704e7049f540477',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 0 },
      { entity: 'symbiotic', startTimestamp: 0 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x0A0B1c677c95b8B3b5095e3e6702f4432E90c0f5',
    additionalTokens: [
      '0x3F1c547b21f65e10480dE3ad8E19fAAC46C95034',
      '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'PMV-1',
    lpTokenDecimals: 18,
    withdrawDuration: 120,
    withdrawDurationDisplay: '<2 minutes',
    allocations: {
      showAllocationsTab: true,
    },
  },
  // Multi vault pre-deposit tests
  {
    id: 'holesky-mellow-pre-deposit-vault-1',
    type: 'multi-vault',
    name: 'Mellow Pre-deposit Vault 1 (Holesky)',
    description: 'Mellow Pre-deposit Vault 1',
    category: 'restaking',
    address: '0x13f45b2Fd1dFb3f7d0d39162889c554660359005',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x6dea56807061086eA259865345739021AE043D71',
    additionalTokens: ['0x94373a4919B3240D86eA41593D5eBa789FEF3848'],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
      {
        address: '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MPV-1',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 3600,
    withdrawDurationDisplay: '<2 hours',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'holesky-mellow-pre-deposit-vault-2',
    type: 'multi-vault',
    name: 'Mellow Pre-deposit Vault 2 (Holesky)',
    description: 'Mellow Pre-deposit Vault 2',
    category: 'restaking',
    address: '0x91302f52e5EF62cc618276DcD1960Dd69d5c8B47',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x6dea56807061086eA259865345739021AE043D71',
    additionalTokens: ['0x94373a4919B3240D86eA41593D5eBa789FEF3848'],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
      {
        address: '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MPV-2',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 3600,
    withdrawDurationDisplay: '<2 hours',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'holesky-mellow-pre-deposit-vault-3',
    type: 'multi-vault',
    name: 'Mellow Pre-deposit Vault 3 (Holesky)',
    description: 'Mellow Pre-deposit Vault 3',
    category: 'restaking',
    address: '0x9F694B85a80ef52Fd7A3D697e56647dDAd559789',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 1738573595 },
      { entity: 'symbiotic', startTimestamp: 1738573595 },
    ],
    layer: 'Symbiotic',
    network: 'holesky',
    depositWrapper: '0x6dea56807061086eA259865345739021AE043D71',
    additionalTokens: ['0x94373a4919B3240D86eA41593D5eBa789FEF3848'],
    depositTokens: [
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
      {
        address: '0x94373a4919B3240D86eA41593D5eBa789FEF3848',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0x6dea56807061086eA259865345739021AE043D71',
      },
    ],
    // vault.asset()
    baseToken: '0x8d09a4502Cc8Cf1547aD300E066060D043f6982D',
    lpTokenSymbol: 'MPV-3',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 3600,
    withdrawDurationDisplay: '<2 hours',
    badge: 'Lido v3',
    allocations: {
      showAllocationsTab: true,
    },
  },
];

const monadVaults: Vault[] = [monadVault];

const mezoVaults: Vault[] = [
  mezoBtcVault,
  mezoBtcPreDepositVault,
  mezoCbBtcVault,
  mezoCbBtcPreDepositVault,
  mezoStableVault,
  ethereumMezoStableVault,
];

const rootstockVaults: Vault[] = [rootstockTyrRbtcVault];

const _vaults: Vault[] = [
  ...ethDVVVaults,
  ...ethVaults,
  ...monadVaults,
  ...mezoVaults,
  ...ethLidoV3Vaults,
  ...bscVaults,
  ...liskVaults,
  ...fraxtalVaults,
  ...holeskyVaults,
  TheoriqStakingPoolVault,
  ...rootstockVaults,
];

export const productionVaults = [..._vaults];

// Staging Test vault
if (isDev || !isProductionApp()) {
  vaultsStaging.forEach(vault => {
    if (!_vaults.find(e => e.id === vault.id)) {
      // pass archived: true first
      // to have an opportunity to
      // override it at vault config
      _vaults.push({ archived: true, ...vault });
    } else {
      throw new Error(
        `You try to add vault ${vault.id} to vaults list for staging. But it already exists.`,
      );
    }
  });
}

// // Dev Test vault
if (isDev) {
  vaultsDev.forEach(vault => {
    if (!_vaults.find(e => e.id === vault.id)) {
      _vaults.push({ ...vault, archived: true });
    } else {
      throw new Error(
        `You try to add vault ${vault.id} to vaults list for development. But it already exists.`,
      );
    }
  });
}

export const vaults: Vault[] = _vaults;

export default vaults;
